import {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import api from "../../api";

function PersonnelEditForm() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  // =====================
  // FORM
  // =====================

  const [form, setForm] =
    useState({
      nom: "",
      prenom: "",
      post_nom: "",
      telephone: "",
      fonction: "",
      salaire_base: ""
    });

  const [loading, setLoading] =
    useState(false);

  const [fetching, setFetching] =
    useState(true);

  // =====================
  // FETCH
  // =====================

  useEffect(() => {

    const fetchPersonnel =
      async () => {

        try {

          setFetching(true);

          const res =
            await api.get(
              `/personnel/${id}`
            );

          // IMPORTANT :
          // l'API renvoie :
          //
          // {
          //   personnel: {...},
          //   salaires: [...]
          // }
          //
          // Les données de l'agent
          // se trouvent donc dans
          // res.data.personnel

          const personnel =
            res.data.personnel;

          if (!personnel) {

            throw new Error(
              "Personnel introuvable"
            );

          }

          // =====================
          // PRÉREMPLISSAGE
          // =====================

          setForm({
            nom:
              personnel.nom ?? "",

            prenom:
              personnel.prenom ?? "",

            post_nom:
              personnel.post_nom ?? "",

            telephone:
              personnel.telephone ?? "",

            fonction:
              personnel.fonction ?? "",

            salaire_base:
              personnel.salaire_base ?? ""
          });

        } catch (err) {

          console.error(
            "Erreur récupération personnel :",
            err
          );

          alert(
            "Impossible de récupérer les données du personnel."
          );

          navigate(
            "/personnel"
          );

        } finally {

          setFetching(false);

        }

      };

    if (id) {
      fetchPersonnel();
    }

  }, [id, navigate]);

  // =====================
  // CHANGE
  // =====================

  const handleChange =
    (e) => {

      const {
        name,
        value
      } = e.target;

      // Téléphone
      if (
        name ===
        "telephone"
      ) {

        let cleaned =
          value.replace(
            /[^0-9+]/g,
            ""
          );

        // Garder uniquement
        // un + au début
        if (
          cleaned.includes("+")
        ) {

          cleaned =
            "+" +
            cleaned.replace(
              /\+/g,
              ""
            );

        }

        setForm(
          (prev) => ({
            ...prev,
            [name]:
              cleaned
          })
        );

        return;
      }

      setForm(
        (prev) => ({
          ...prev,
          [name]:
            value
        })
      );

    };

  // =====================
  // SUBMIT
  // =====================

  const handleSubmit =
    async () => {

      if (
        !window.confirm(
          "Confirmer la modification de cet agent ?"
        )
      ) {

        return;

      }

      setLoading(true);

      try {

        await api.put(
          `/personnel/${id}`,
          {
            nom:
              form.nom,

            prenom:
              form.prenom,

            post_nom:
              form.post_nom,

            telephone:
              form.telephone,

            fonction:
              form.fonction,

            salaire_base:
              form.salaire_base
          }
        );

        alert(
          "Personnel modifié avec succès."
        );

        navigate(
          "/personnel"
        );

      } catch (err) {

        console.error(
          "Erreur modification personnel :",
          err
        );

        alert(
          "Erreur lors de la modification du personnel."
        );

      } finally {

        setLoading(false);

      }

    };

  // =====================
  // CHARGEMENT
  // =====================

  if (fetching) {

    return (

      <div className="min-h-[100dvh] bg-gray-100 flex items-center justify-center px-4">

        <div className="bg-white rounded-2xl shadow-lg px-6 py-8 text-center">

          <p className="text-gray-600">
            Chargement des informations du personnel...
          </p>

        </div>

      </div>

    );

  }

  // =====================
  // RENDER
  // =====================

  return (

    <div className="min-h-[100dvh] bg-gray-100 px-3 md:px-6 py-4 md:py-6">

      <div className="max-w-4xl mx-auto">

        {/* =====================
            NAV
        ===================== */}

        <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-6">

          <button
            onClick={() =>
              navigate(
                "/dashboard"
              )
            }
            className="bg-gray-200 hover:bg-gray-300 transition px-4 py-3 rounded-xl"
          >
            ← Dashboard
          </button>

          <button
            onClick={() =>
              navigate(
                "/personnel"
              )
            }
            className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-3 rounded-xl"
          >
            Liste personnel →
          </button>

        </div>

        {/* =====================
            CARD
        ===================== */}

        <div className="bg-white rounded-2xl shadow-lg p-4 md:p-8">

          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
            Modifier personnel
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* =====================
                NOM
            ===================== */}

            <div>

              <label className="text-sm text-gray-600">
                Nom
              </label>

              <input
                name="nom"
                value={
                  form.nom
                }
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-blue-400"
              />

            </div>

            {/* =====================
                POST-NOM
            ===================== */}

            <div>

              <label className="text-sm text-gray-600">
                Post-nom
              </label>

              <input
                name="post_nom"
                value={
                  form.post_nom
                }
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-blue-400"
              />

            </div>

            {/* =====================
                PRÉNOM
            ===================== */}

            <div>

              <label className="text-sm text-gray-600">
                Prénom
              </label>

              <input
                name="prenom"
                value={
                  form.prenom
                }
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-blue-400"
              />

            </div>

            {/* =====================
                TÉLÉPHONE
            ===================== */}

            <div>

              <label className="text-sm text-gray-600">
                Téléphone
              </label>

              <input
                name="telephone"
                value={
                  form.telephone
                }
                onChange={
                  handleChange
                }
                placeholder="+243XXXXXXXXX"
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-blue-400"
              />

            </div>

            {/* =====================
                FONCTION
            ===================== */}

            <div>

              <label className="text-sm text-gray-600">
                Fonction
              </label>

              <input
                name="fonction"
                value={
                  form.fonction
                }
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-blue-400"
              />

            </div>

            {/* =====================
                SALAIRE
            ===================== */}

            <div>

              <label className="text-sm text-gray-600">
                Salaire
              </label>

              <input
                name="salaire_base"
                type="number"
                value={
                  form.salaire_base
                }
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 w-full outline-none focus:ring-2 focus:ring-blue-400"
              />

            </div>

          </div>

          {/* =====================
              ACTIONS
          ===================== */}

          <div className="flex flex-col md:flex-row gap-3 mt-6">

            <button
              onClick={() =>
                navigate(
                  "/personnel"
                )
              }
              disabled={
                loading
              }
              className="flex-1 bg-gray-200 hover:bg-gray-300 transition py-3 rounded-xl font-semibold disabled:opacity-50"
            >
              Annuler
            </button>

            <button
              onClick={
                handleSubmit
              }
              disabled={
                loading
              }
              className="flex-1 bg-blue-600 hover:bg-blue-700 transition text-white py-3 rounded-xl font-semibold disabled:opacity-50"
            >
              {loading
                ? "Enregistrement..."
                : "Enregistrer modifications"}
            </button>

          </div>

        </div>

      </div>

    </div>

  );

}

export default PersonnelEditForm;